module.exports = __webpack_public_path__ + "static/media/services-item-tools-bg.21c25edd.svg";